import { StatusPill } from "./StatusPill";

export function EditorialFooter() {
  return (
    <footer className="mt-16 border-t border-ruleline bg-parchment-100">
      <div className="mx-auto flex max-w-masthead items-center justify-between gap-4 px-6 py-6 text-xs text-warmgray-400">
        <span>
          © Eryndal · S<span className="text-oxblood-500">ai</span>gar's Bot
        </span>
        <span className="font-serif italic">Drafted by agents. Reviewed by humans.</span>
        <StatusPill />
      </div>
    </footer>
  );
}
